// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag {
  width: max-content;
  height: 2.6rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--black);
  padding: 0 0.6rem;
  border: 0.1rem solid var(--primary-10);
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: border-color 0.3s;
}
.tag:hover {
  border-color: var(--primary);
}
.tag i {
  color: var(--grey-icon);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/shared/tag/tag.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AACF;AACE;EACE,4BAAA;AACJ;AAEE;EACE,uBAAA;EACA,eAAA;AAAJ","sourcesContent":[".tag {\n  width: max-content;\n  height: 2.6rem;\n  font-size: 1.2rem;\n  line-height: 1.4rem;\n  color: var(--black);\n  padding: 0 0.6rem;\n  border: 0.1rem solid var(--primary-10);\n  border-radius: 0.4rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: border-color 0.3s;\n\n  &:hover {\n    border-color: var(--primary);\n  }\n\n  & i {\n    color: var(--grey-icon);\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
